import React, { useState, useEffect } from "react";
import {
  Layout,
  Modal,
  Tooltip,
  Button,
  Menu,
  Dropdown,
  Space,
  Checkbox,
} from "antd";
import {
  CloseOutlined,
  PlusOutlined,
  CaretDownOutlined,
} from "@ant-design/icons";
import Header from "./Header";
import EmployeeDetails from "./EmployeeDetails";
import SchedulingApproval from "../../../components/scheduling/SchedulingApproval";
import AddEmployeeScheduling from "./AddEmployeeScheduling";
import EmployeeSalaryModal from "../../salary/employeeSalary/index";
import RestrictedComponent from "../../../components/util/RestrictedComponent";
import {
  setMonth,
  setYear,
  setBranch,
  loadSalaryLines,
  recalculateEmployee,
  approveEmployee,
} from "../../salary/salarySlice";
import { listEmployeesSalary } from "../../../api/server";
import moment from "moment";
import { useLocation, useParams } from "react-router-dom";
import { useMedia } from "react-media";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { usePermission } from "../../../hooks/accessControl";
import _ from "lodash";
import { useQuery } from "react-query";
import { getEmployeeTimewatch } from "../../../api/server";

const GLOBAL_MEDIA_QUERIES = {
  small: "(max-width: 899px)",
};
const ApprovalModal = (props) => {
  const {
    visible,
    onHide,
    currentDate,
    onFilterPatientsChanged,
    onNextMonth,
    onPreviousMonth,
    filteredOrders,
    events,
    originalEvents,
    loadLoading,
    ordersIds,
    patientsPallette,
    reload,
    changeEvents,
    holidays,
    order_time_extractions,
    absences,
  } = props;
  const intl = useIntl();
  const dispatch = useDispatch();
  let { branchId } = useParams();
  let location = useLocation();
  const isAdmin = location.pathname.includes("admin");
  const [addSchedulingVisible, setAddSchedulingVisible] = useState(false);
  const [changes, setChanges] = useState({ approval: [], events: [] });
  const [mode, setMode] = useState(null);
  const [employeeSalaryVisible, setEmployeeSalaryVisible] = useState(false);
  const [isApproved, setIsApproved] = useState(null);
  const [isLocked, setIsLocked] = useState(null);
  const [salaryRunAt, setSalaryRunAt] = useState(null);
  const [quickEdit, setQuickEdit] = useState(false);
  const [summary, setSummary] = useState(null);
  const [employeePatients, setEmployeePatients] = useState([]);
  const [showOk2goEvents, setShowOk2goEvents] = useState(true);
  const [timewatchEvents, setTimewatchEvents] = useState([]);
  const [showTimewatchEvents, setShowTimewatchEvents] = useState(false);

  const scopePrefix = useSelector((state) => state.user.scopePrefix);
  const activeEmployee = useSelector(
    (state) => state.employeeDetails.activeEmployee
  );

  useEffect(() => {
    const patients =
      events &&
      events.length > 0 &&
      events
        .map((i) => i.order.patient)
        .filter((v, j, a) => a.findIndex((t) => t.id === v.id) === j);

    const sortedPatients =
      patients &&
      _.sortBy(patients, [
        function (o) {
          return o.surename;
        },
      ]);
    setEmployeePatients(sortedPatients);
  }, [events]);

  useEffect(() => {
    if (isApproved || isLocked || !salaryRunAt) {
      setMode("view");
    } else {
      setMode("edit");
    }
  }, [isApproved, isLocked, salaryRunAt]);

  const getSalaryData = async () => {
    const activeYear = moment(currentDate).format("YYYY");
    const activeMonth = moment(currentDate).format("M");
    if (activeYear && activeMonth) {
      const query = {
        year: activeYear,
        month: activeMonth,
      };
      const unique =
        activeEmployee &&
        activeEmployee.foreign &&
        activeEmployee.foreign.passport_number
          ? activeEmployee.foreign.passport_number
          : activeEmployee.local_id_number
          ? activeEmployee.local_id_number
          : null;
      const page = {
        current: 1,
        pageSize: 1,
        filter: {
          freeText: unique,
        },
        order: {},
      };
      const branchId = activeEmployee.salary_branch_id;
      const scope = `branches/${branchId}/`;
      const path = "salary";
      const data = await listEmployeesSalary({
        ...page,
        scopePrefix: scope,
        path,
        query,
      });
      if (data && data.data) {
        return data.data;
      } else {
        return null;
      }
    }
  };

  const closeModal = () => {
    onHide();
    setQuickEdit(false);
  };
  const onAddSchedulingClick = () => {
    setAddSchedulingVisible(true);
  };

  const onOk2goFilterChange = (e) => {
    setShowOk2goEvents(e.target.checked);
  };

  const hideEmployeeScheduling = () => {
    setAddSchedulingVisible(false);
  };
  const matches = useMedia({ queries: GLOBAL_MEDIA_QUERIES });

  let filtered = [];
  events.forEach((item, i) => {
    var isFiltered = filteredOrders?.includes(item.order.id);
    if (!isFiltered) {
      filtered.push(item);
    }
  });

  const setSchedulingChanges = (val) => {
    setChanges(val);
  };

  const showAddSalaryLine = async (e) => {
    var month = currentDate ? currentDate.format("M") : null;
    dispatch(setMonth({ month: month }));
    var year = currentDate ? currentDate.format("YYYY") : null;
    dispatch(setYear({ year: year }));
    dispatch(
      setBranch({
        branch: branchId
          ? branchId
          : activeEmployee.branch_active &&
            activeEmployee.branch_active[0] &&
            activeEmployee.branch_active[0].branch_id,
      })
    );
    const isAdmin = location.pathname.includes("admin");
    const salaryData = await getSalaryData();
    const approved =
      salaryData &&
      salaryData.items &&
      salaryData.items[0] &&
      salaryData.items[0].approved;
    const isLocked =
      salaryData && salaryData.summary && salaryData.summary.locked;
    const salaryRun =
      salaryData && salaryData.summary && salaryData.summary.salary_run_at;

    dispatch(loadSalaryLines(isAdmin, activeEmployee.id));
    setIsApproved(approved);
    setIsLocked(isLocked);
    setSummary(salaryData && salaryData.summary);
    setSalaryRunAt(salaryRun);
    setEmployeeSalaryVisible(true);
  };

  const onHideEmployeeSalaryModal = () => {
    setEmployeeSalaryVisible(false);
  };
  var year = currentDate ? moment(currentDate).format("YYYY") : null;
  var month = currentDate ? moment(currentDate).format("M") : null;
  const branch = branchId
    ? branchId
    : activeEmployee.branch_active &&
      activeEmployee.branch_active[0] &&
      activeEmployee.branch_active[0].branch_id;
  const onRecalculate = async (employeeId) => {
    const params = {
      branchId: branch,
      employeeId: employeeId,
      period: {
        year: +year,
        month: +month,
      },
    };
    return dispatch(recalculateEmployee(params));
  };

  const onApprove = async (employeeId, approved) => {
    const params = {
      branchId: branch,
      employeeId: employeeId,
      period: {
        year: +year,
        month: +month,
      },
    };
    const action = await dispatch(approveEmployee(params));
    if (!action.error) {
      setIsApproved(!approved);
    }
  };

  const onQuickEditChange = (e) => {
    setQuickEdit(e.target.checked);
  };

  const hasSalaryViewerPermission = usePermission(
    branchId,
    "branch_salary",
    "viewer"
  );

  const dropDownMenu = {
    items: [
      {
        label: intl.formatMessage({
          id: "app.salary.edit_employee_salary",
        }),
        key: "1",
      },
    ],
    onClick: (e) => showAddSalaryLine(e),
  };

  const includedEvents = showOk2goEvents
    ? events
    : events.filter((event) => !event.ok2go_info?.id);

  const { data: fetchedTimewatchEvents, isLoading: isLoadingTimewatch } =
    useQuery(
      [
        "employeeTimewatch",
        isAdmin,
        branchId,
        activeEmployee?.id,
        currentDate?.format("YYYY-MM"),
      ],
      () => {
        const startDate = moment(currentDate).startOf("month").format();
        const endDate = moment(currentDate).endOf("month").format();
        const filter = {
          timestamp: {
            $gte: startDate,
            $lte: endDate,
          },
        };

        const params = {
          query: {
            offset: 0,
            limit: 100,
            filter,
            sort: ["+timestamp"],
          },
        };

        return getEmployeeTimewatch(
          isAdmin ? null : branchId,
          activeEmployee?.id,
          params
        );
      },
      {
        enabled:
          visible &&
          !!activeEmployee?.id &&
          !!currentDate &&
          (isAdmin || !!branchId),
        select: (data) => {
          if (!data?.data || !data?.data?.items) return [];
          return data.data.items;
        },
      }
    );

  useEffect(() => {
    if (fetchedTimewatchEvents) {
      setTimewatchEvents(fetchedTimewatchEvents);
    }
  }, [fetchedTimewatchEvents]);

  useEffect(() => {
    if (fetchedTimewatchEvents && fetchedTimewatchEvents.length > 0) {
      setShowTimewatchEvents(true);
    }
  }, [fetchedTimewatchEvents]);

  const onTimewatchEventsChange = (e) => {
    setShowTimewatchEvents(e.target.checked);
  };
  return (
    <Modal
      width={"vw"}
      style={{
        height: "100vh",
        maxWidth: "100vw",
        position: "absolute",
        top: 0,
        left: 0,
      }}
      styles={{
        body: {
          height: "100vh",
          width: "100vw",
          padding: "10px",
        },
      }}
      closable={false}
      open={visible}
      footer={null}
      className={"no-padding no-border-radius"}
      destroyOnClose={true}
    >
      <Layout style={{ background: "transparent" }}>
        <Tooltip title="close">
          <Button
            onClick={closeModal}
            size="large"
            style={{ position: "absolute", right: 10, top: 10 }}
            shape="circle"
            icon={<CloseOutlined />}
          />
        </Tooltip>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            // padding: "40px 0 10px 0",
          }}
        >
          <Header
            currentDate={currentDate}
            onNextDate={onNextMonth}
            onPreviousDate={onPreviousMonth}
            onFilterPatientsChanged={onFilterPatientsChanged}
            ordersIds={ordersIds}
            events={events}
            patientsPallette={patientsPallette}
            modal={true}
            comp={
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {matches.small ? null : (
                  <EmployeeDetails record={activeEmployee} />
                )}
                <Space size="middle">
                  {fetchedTimewatchEvents?.length > 0 && (
                    <Checkbox
                      onChange={onTimewatchEventsChange}
                      checked={showTimewatchEvents}
                    >
                      {intl.formatMessage({
                        id: "app.scheduling.timewatchEvents",
                      })}
                    </Checkbox>
                  )}
                  <Checkbox
                    onChange={onOk2goFilterChange}
                    checked={showOk2goEvents}
                  >
                    {intl.formatMessage({
                      id: "app.scheduling.ok2go_filter",
                    })}
                  </Checkbox>
                  <Checkbox onChange={onQuickEditChange} checked={quickEdit}>
                    {intl.formatMessage({
                      id: "app.scheduling.quickSchedulingEdit",
                    })}
                  </Checkbox>
                  <Dropdown.Button
                    icon={hasSalaryViewerPermission && <CaretDownOutlined />}
                    style={{ margin: "10px 0", alignSelf: "end" }}
                    type="primary"
                    onClick={onAddSchedulingClick}
                    size="small"
                    disabled={changes.events.length > 0}
                    menu={
                      hasSalaryViewerPermission ? dropDownMenu : { items: [] }
                    }
                  >
                    <PlusOutlined />{" "}
                    {intl.formatMessage({
                      id: "app.scheduling.addNewScheduling",
                    })}
                  </Dropdown.Button>
                </Space>
              </div>
            }
            order_time_extractions={order_time_extractions}
            filteredOrders={filteredOrders}
          />
          <SchedulingApproval
            fromEmployee={true}
            filteredOrders={filteredOrders}
            events={includedEvents}
            originalEvents={originalEvents}
            loadLoading={loadLoading}
            reload={reload}
            changeEvents={changeEvents}
            holidays={holidays}
            setSchedulingChanges={setSchedulingChanges}
            absences={absences}
            currentDate={currentDate}
            quickEdit={quickEdit}
            timewatchEvents={timewatchEvents}
            isLoadingTimewatch={isLoadingTimewatch}
            showTimewatchEvents={showTimewatchEvents}
          />
          <AddEmployeeScheduling
            visible={addSchedulingVisible}
            handleCancel={hideEmployeeScheduling}
            activeEmployee={activeEmployee}
            reload={reload}
            currentDate={currentDate}
            employeePatients={employeePatients}
          />
          <EmployeeSalaryModal
            record={{ employee: activeEmployee }}
            onHide={onHideEmployeeSalaryModal}
            visible={employeeSalaryVisible}
            mode={mode}
            onRecalculate={onRecalculate}
            onApprove={onApprove}
            employeeId={activeEmployee.id}
            activeYear={moment(currentDate)
              .subtract(1, "months")
              .format("YYYY")}
            activeMonth={moment(currentDate).subtract(1, "months").format("M")}
            isApproved={isApproved}
            summary={summary}
          />
        </div>
      </Layout>
    </Modal>
  );
};

export default ApprovalModal;
